import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import './ProjectCard.css';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import {Card , ListGroup ,ListGroupItem ,Carousel} from 'react-bootstrap';
import { NavLink } from "react-router-dom";



const ProjectCard = ({Title , Text , image1 , image2 ,image3 ,image4 , interval ,tolink}) => {
    const { t, i18n } = useTranslation();

    return (
        <Card className='maincard' >
            <Carousel>
                <Carousel.Item interval={interval}>
                    <img src={image1} className="d-block w-100" />
                </Carousel.Item>
                <Carousel.Item interval={interval}>
                    <img src={image2} className="d-block w-100" />
                </Carousel.Item>
                <Carousel.Item interval={interval}>
                    <img src={image3} className="d-block w-100" />
                </Carousel.Item>
                <Carousel.Item interval={interval}>
                    <img src={image4} className="d-block w-100" />
                </Carousel.Item>
            </Carousel>
        <Card.Body>

          <Card.Title>{Title}</Card.Title>       
        </Card.Body>
        <ListGroup className="list-group-flush">
          <ListGroupItem>{Text}
            <Card.Link><NavLink to={tolink} >{t('more_info')}</NavLink></Card.Link>
            </ListGroupItem>
        </ListGroup>
      </Card>
    )
}

export default ProjectCard
